/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerMemo } from '../../models/customer-memo';

export interface CreateCustomerMemo$Params {
      body: CustomerMemo
}

export function createCustomerMemo(http: HttpClient, rootUrl: string, params: CreateCustomerMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerMemo>> {
  const rb = new RequestBuilder(rootUrl, createCustomerMemo.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerMemo>;
    })
  );
}

createCustomerMemo.PATH = '/customermemo';
